import React from "react";

import Chip from "@mui/material/Chip";
import { t } from "@auto/services";
import { OperatorUserListWidget } from "@auto/users/__OperatorUserListWidget";
import { operatorRoleLabelKey, operatorScopeLabelKey, operatorTerritory } from "./operatorTerritory";

const enrichRows = (rows) => rows.map((row) => {
  const scope = operatorTerritory(row);
  return { ...row, operatorScope: scope,
    operatorTypeName: scope.role, operatorScopeLabel: scope.territoryLabel };
});

const extraColumns = [
  {
    title: "operator.type",
    field: "operatorTypeName",
    sorting: false,
    render: (row) => <Chip size="small" variant="outlined"
      label={t(operatorRoleLabelKey(row.operatorScope?.role))} />
  },
  {
    title: "operator.scope",
    field: "operatorScopeLabel",
    sorting: false,
    render: (row) => row.operatorScope?.valid
      ? `${t(operatorScopeLabelKey(row.operatorScope.role))}: ${row.operatorScope.territoryLabel}`
      : t("operator.scope.unassigned")
  }
];

export const displayOperatorUserList = (gui) => ({
  uuid: "operator-user-list",
  view: () => <OperatorUserListWidget
    gui={gui}
    enrichRows={enrichRows}
    extraColumns={extraColumns}
  />
});

export default displayOperatorUserList;
